import React, { FC, useEffect, useState } from "react"
import { Carousel, Col, Divider, Layout, Row, Space, Switch, Table, Tag } from "antd"
import { HeaderText } from "./common/HeaderText"
import { Match } from "../models/Match"
import { PointSystem } from "../models/leaderboards/PointSystem"
import { calculatePointsPerMatch, leaderboardTotal } from "../services/StatAggregatorService"
import { pointSystem as testPointSystem } from "../models/test/SolosPointSystem"
import { translateColumn } from "../util/Translate"

const { Content, Header } = Layout

export interface AwardsProp {
    bounties: Array<string>
    matches: Array<Match>
    stats: Array<any>
    pointSystem?: PointSystem
    hideHeader?: boolean
}

export const Awards: FC<AwardsProp> = (props) => {
    const [bounties, setBounties] = useState<Array<string>>([])
    const [matches, setMatches] = useState<Array<Match>>([])
    const [stats, setStats] = useState<Array<Match>>([])
    const [pointSystem, setPointSystem] = useState<PointSystem>(testPointSystem)
    const [beta, setBeta] = useState<boolean>(false)

    useEffect(() => {
        setBounties(props.bounties)
    }, [props.bounties])

    useEffect(() => {
        setMatches(props.matches)
    }, [props.matches])

    useEffect(() => {
        setStats(props.stats)
    }, [props.stats])

    useEffect(() => {
        if (props.pointSystem) {
            setPointSystem(props.pointSystem)
        }
    }, [props.pointSystem])

    const displayPlacement = () => {
        if (props.matches.length > 0) {
            const tournamentPoints = calculatePointsPerMatch(matches, pointSystem)
            const totals = leaderboardTotal(props.matches.length, tournamentPoints)

            const columns: Array<any> = [
                {
                    title: "#",
                    dataIndex: "index",
                    key: "index",
                    width: "64px"
                },
                {
                    title: "Players",
                    dataIndex: "players",
                    key: "players",
                    width: "40%",
                    render: (players: Array<any>) => players.map((player) => { return <Tag key={"total-" + player}>{player}</Tag> })
                },
                {
                    title: "Points",
                    dataIndex: "total",
                    key: "total",
                    width: "20%"
                },
                {
                    title: "Kills",
                    dataIndex: "kills",
                    key: "kills",
                    width: "20%"
                },
                {
                    title: "Damage",
                    dataIndex: "damage",
                    key: "damage",
                    width: "20%",
                    render: (damageDealt: number) => damageDealt.toFixed(2)
                }
            ]

            if (totals.length > 0) {
                const data: Array<any> = []
                for (var i = 0; i < 5; i++) {
                    const newIndex = i + 1;
                    data.push({
                        key: totals[i]["players"],
                        index: newIndex,
                        ...totals[i]
                    })
                }

                return (<Table columns={columns} dataSource={data} pagination={false} title={() => "Placement"} />)
            }
        }
    }

    const carouselBounty = (bounty: string) => {
        if (stats.length > 0) {
            const tempArray: Array<any> = stats.sort((a: any, b: any) => {
                return b[bounty] - a[bounty] || b["kills"] - a["kills"] || b["damageDealt"] - a["damageDealt"]
            })
            const data: Array<any> = []
            for (var i = 0; i < 5; i++) {
                const newIndex = i + 1;
                data.push({
                    key: tempArray[i]["name"],
                    index: newIndex,
                    ...tempArray[i]
                })
            }
            const columns: Array<any> = [
                {
                    title: "#",
                    dataIndex: "index",
                    key: "index",
                    width: "64px"
                },
                {
                    title: "Player",
                    dataIndex: "name",
                    key: "name",
                    width: "40%"
                },
                {
                    title: translateColumn(bounty),
                    key: bounty,
                    dataIndex: bounty,
                    render: (value: number) => {
                        if (value % 1 !== 0) {
                            return value.toFixed(2)
                        } else {
                            return value
                        }
                    }
                }
            ]
            if (bounty !== "kills") {
                columns.push({
                    title: "Kills",
                    dataIndex: "kills",
                    key: "kills"
                })
            }
            columns.push({
                title: "Damage",
                dataIndex: "damageDealt",
                key: "damageDealt",
                render: (damageDealt: number) => damageDealt.toFixed(2)
            })
            return (<Table columns={columns} dataSource={data} title={() => translateColumn(bounty)} pagination={false} key={"awards-" + translateColumn(bounty)} />)
        }
    }

    const displayBounties = () => {
        if (stats.length > 0) {
            const stuff: Array<any> = []
            for (const bounty of bounties) {
                const tempArray: Array<any> = stats.sort((a: any, b: any) => {
                    return b[bounty] - a[bounty] || b["kills"] - a["kills"] || b["damageDealt"] - a["damageDealt"]
                })
                const data: Array<any> = []
                for (var i = 0; i < 5; i++) {
                    const newIndex = i + 1;
                    data.push({
                        key: tempArray[i]["name"],
                        index: newIndex,
                        ...tempArray[i]
                    })
                }
                const columns: Array<any> = [
                    {
                        title: "#",
                        dataIndex: "index",
                        key: "index",
                        width: "64px"
                    },
                    {
                        title: "Player",
                        dataIndex: "name",
                        key: "name",
                        width: "40%"
                    },
                    {
                        title: translateColumn(bounty),
                        key: bounty,
                        dataIndex: bounty,
                        render: (value: number) => {
                            if (value % 1 !== 0) {
                                return value.toFixed(2)
                            } else {
                                return value
                            }
                        }
                    }
                ]
                if (bounty !== "kills") {
                    columns.push({
                        title: "Kills",
                        dataIndex: "kills",
                        key: "kills"
                    })
                }
                columns.push({
                    title: "Damage",
                    dataIndex: "damageDealt",
                    key: "damageDealt",
                    render: (damageDealt: number) => damageDealt.toFixed(2)
                })
                stuff.push(
                    <>
                        <Divider />
                        <Table columns={columns} dataSource={data} title={() => translateColumn(bounty)} pagination={false} />
                    </>
                )
            }
            return (
                <Col>
                    {stuff}
                </Col>
            )
        }
    }

    return (
        <Layout>
            {!props?.hideHeader &&
                <>
                    <Header>
                        <Row justify="space-between" align="middle" >
                            <HeaderText title={"Awards"} />
                            <Space>
                                <Switch onChange={() => setBeta(!beta)} />
                                BETA
                            </Space>
                        </Row>
                    </Header>
                    <Divider />
                </>
            }
            {
                props.hideHeader &&
                <Space style={{marginBottom: 24}}>
                    <Switch onChange={() => setBeta(!beta)} />
                    BETA
                    <br/>
                </Space>
            }
            <Content>
                {!beta &&
                    <>
                        <Col>
                            <Row align="middle" justify="space-around">
                                <HeaderText title={"Placements"} />
                            </Row>
                            {displayPlacement()}
                        </Col>
                        <Divider />
                        <Col>
                            <Row align="middle" justify="space-around">
                                <HeaderText title={"Bounties"} />
                            </Row>
                            {displayBounties()}
                        </Col>
                    </>
                }
                {beta &&
                    <Carousel style={{ paddingBottom: 40 }} dotPosition={"bottom"} arrows={true}>
                        {displayPlacement()}
                        {bounties.map((bounty) => carouselBounty(bounty))}
                    </Carousel>
                }
            </Content>
        </Layout>
    )
}